import { useContext, useRef } from 'react'
import type { ConnectedProps } from 'react-redux'
import { connect } from 'react-redux'

import {
  TripPlannerStickyHeader,
  TripPlannerHeaderCentreContent,
  TripPlannerStyledLogo,
  FlexBreakpoint,
  LeftContent,
} from './Shared'

import IconButton from 'LuxKit/Button/IconButton'
import TextButton from 'LuxKit/Button/TextButton'
import ArrowLeftIcon from 'LuxKit/Icons/line/LineArrowLeftIcon'
import { useHeaderStateObserver } from 'contexts/HeaderStateContext'
import { HeaderInViewContext } from 'tripPlanner/contexts/HeaderInViewContext'

const mapState = (state: App.State) => ({
  headlessMode: state.system.headlessMode,
})

const connector = connect(mapState)

type PropsFromRedux = ConnectedProps<typeof connector>

interface Props extends PropsFromRedux {
  backTo: string
  backLabel: string
}

function HeaderBasic({ backTo, backLabel, headlessMode }: Props) {
  const rootRef = useRef<HTMLElement>(null)
  useHeaderStateObserver('tripPlanner', rootRef)
  const { inView } = useContext(HeaderInViewContext)

  return (
    <TripPlannerStickyHeader ref={rootRef}>
      {inView && !headlessMode && (
        <TextButton
          kind="tertiary"
          variant="dark"
          size="large"
          startIcon={<ArrowLeftIcon />}
          to={backTo}
        >
          {backLabel}
        </TextButton>
      )}
      {(!inView || headlessMode) && (
        <LeftContent>
          {!headlessMode && (
            <IconButton
              kind="tertiary"
              variant="dark"
              size="large"
              to={backTo}
              aria-label={backLabel}
            >
              <ArrowLeftIcon />
            </IconButton>
          )}
        </LeftContent>
      )}

      <TripPlannerHeaderCentreContent to="/">
        {inView && !headlessMode && (
          <FlexBreakpoint max="tablet">
            <TripPlannerStyledLogo />
          </FlexBreakpoint>
        )}
        <FlexBreakpoint min="desktop">
          <TripPlannerStyledLogo />
        </FlexBreakpoint>
      </TripPlannerHeaderCentreContent>
    </TripPlannerStickyHeader>
  )
}

export default connector(HeaderBasic)
